import {convertUTCToLocal} from '@/utility/dateHelper'
export const GetFormattedWarehouseTargetData = (apiResponse = {}) => {
  const {data, totalRecords = '', totalPages = '', activeCount = '', currentPage = '', pageSize = ''} = apiResponse
  const formattedWarehouseTarget = data?.map(GetWarehouseTargetData)
  return {
    data: formattedWarehouseTarget,
    totalRecords,
    totalPages,
    activeCount,
    currentPage,
    pageSize,
  }
}
// Helper function to map individual items
const GetWarehouseTargetData = (item = {}) => {
  const {
    id = null,
    warehouseId = null,
    warehouseName = '',
    deliveryService = null,
    deliveryDays = null,
    cutOffTime = null,
    creationDate,
    lastUpdated,
    businessCategory = null,
  } = item
  return {
    id,
    warehouseId,
    warehouseName,
    deliveryService,
    deliveryDays,
    cutOffTime,
    creationDate: convertUTCToLocal(creationDate),
    lastUpdated: convertUTCToLocal(lastUpdated),
    businessCategory,
  }
}
